query simpleSoccerTeams($search: String) {
  teams: allSoccerTeams(
    orderBy: NAME_ASC
    first: 20
    filter: { name: { includesInsensitive: $search } }
  ) {
    nodes {
      id: teamId
      name
    }
  }
}
